import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const UpsertTopUpAdsRBAC = {
  pageID: '1a5cebe5a3337293d1edc746d9da3d45',
  elementID: {
    ViewOnly: 'e157136fa2d295bf58370a2d490e24e2',
  },
} as const

export const useUpsertTopUpAdsRBAC = createUseRBAC(UpsertTopUpAdsRBAC.elementID)

export type UseUpsertTopUpAdsRBACType = ReturnType<typeof useUpsertTopUpAdsRBAC>
